import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { GridFour, Sparkle, MegaphoneSimple, Funnel, SignOut, User } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

const nav = [
  { to: "/app", label: "Overview", icon: GridFour, testId: "nav-overview", end: true },
  { to: "/app/agent-a", label: "Agent A · Orchestrator", icon: Sparkle, testId: "nav-agent-a" },
  { to: "/app/agent-b", label: "Agent B · Ad Studio", icon: MegaphoneSimple, testId: "nav-agent-b" },
  { to: "/app/leads", label: "Leads Pipeline", icon: Funnel, testId: "nav-leads" },
];

export default function DashboardLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate("/login"); };

  return (
    <div className="min-h-screen bg-background text-foreground flex">
      <aside className="hidden lg:flex flex-col w-64 border-r border-white/[0.06] bg-[#070707]">
        <div className="px-6 h-16 border-b border-white/[0.06] flex items-center gap-3">
          <div className="w-7 h-7 border border-primary grid place-items-center primary-glow">
            <span className="font-heading font-black text-primary text-sm">D</span>
          </div>
          <div className="leading-tight">
            <div className="font-heading font-bold text-sm">DW Hub</div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground font-mono">Console</div>
          </div>
        </div>

        <nav className="flex-1 p-3 flex flex-col gap-1">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={n.testId}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-sm text-sm border ${isActive ? "bg-primary/10 border-primary/30 text-foreground" : "border-transparent text-muted-foreground hover:text-foreground hover:bg-white/[0.03]"}`
              }
            >
              <n.icon size={16} weight="regular" />
              <span>{n.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-white/[0.06]">
          <div className="px-3 py-3 flex items-center gap-3 bg-white/[0.02] border border-white/[0.06] rounded-sm">
            <div className="w-8 h-8 rounded-sm bg-primary/15 border border-primary/30 grid place-items-center text-primary">
              <User size={14} weight="regular" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-xs font-medium truncate" data-testid="user-name">{user?.full_name}</div>
              <div className="text-[10px] text-muted-foreground truncate font-mono">{user?.email}</div>
            </div>
            <button data-testid="btn-logout" onClick={handleLogout} className="text-muted-foreground hover:text-destructive transition-colors">
              <SignOut size={16} />
            </button>
          </div>
        </div>
      </aside>

      <main className="flex-1 min-w-0">
        <div className="lg:hidden h-14 border-b border-white/[0.06] px-4 flex items-center justify-between bg-[#070707]">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 border border-primary grid place-items-center"><span className="font-heading font-black text-primary text-xs">D</span></div>
            <span className="font-heading font-bold text-sm">DW Hub</span>
          </div>
          <button data-testid="btn-logout-mobile" onClick={handleLogout} className="text-sm text-muted-foreground"><SignOut size={16} /></button>
        </div>
        <div className="lg:hidden border-b border-white/[0.06] px-2 py-2 flex gap-1 overflow-x-auto bg-[#070707]">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end}
              className={({ isActive }) => `whitespace-nowrap text-xs px-3 py-1.5 rounded-sm border ${isActive ? "border-primary/40 text-primary" : "border-white/10 text-muted-foreground"}`}>
              {n.label}
            </NavLink>
          ))}
        </div>
        <Outlet />
      </main>
    </div>
  );
}
